import { atom } from 'recoil';
import { ITipoRecolocacao } from '../../../commons/types/crm';

export const configTipoRealocacaoAtom = atom<ITipoRecolocacao[]>({
  key: 'configTipoRealocado', 
  default: [] as ITipoRecolocacao[],
}); 
